import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=3b45535e&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_z2a3irye3y56jaq776fqxbsiea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports